'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Clone = require('@hapi/hoek/lib/clone');
var Common = require('./common');
var Messages = require('./messages');
var internals = {};
exports.type = function (from, options) {
  var base = Object.getPrototypeOf(from);
  var prototype = Clone(base);
  var schema = from._assign(Object.create(prototype));
  var def = Object.assign({}, options); // Shallow cloned
  delete def.base;
  prototype._definition = def;
  var parent = base._definition || {};
  def.messages = Messages.merge(parent.messages, def.messages);
  def.properties = Object.assign({}, parent.properties, def.properties);

  // Type

  schema.type = def.type;

  // Flags

  def.flags = Object.assign({}, parent.flags, def.flags);

  // Terms

  var terms = Object.assign({}, parent.terms);
  if (def.terms) {
    for (var name in def.terms) {
      // Only apply own terms
      var term = def.terms[name];
      Assert(schema.$_terms[name] === undefined, 'Invalid term override for', def.type, name);
      schema.$_terms[name] = term.init;
      terms[name] = term;
    }
  }
  def.terms = terms;

  // Constructor arguments

  if (!def.args) {
    def.args = parent.args;
  }

  // Prepare

  def.prepare = internals.prepare(def.prepare, parent.prepare);

  // Coerce

  if (def.coerce) {
    if (typeof def.coerce === 'function') {
      def.coerce = {
        method: def.coerce
      };
    }
    if (def.coerce.from && !Array.isArray(def.coerce.from)) {
      def.coerce = {
        method: def.coerce.method,
        from: [].concat(def.coerce.from)
      };
    }
  }
  def.coerce = internals.coerce(def.coerce, parent.coerce);

  // Validate

  def.validate = internals.validate(def.validate, parent.validate);

  // Rules

  var rules = Object.assign({}, parent.rules);
  if (def.rules) {
    var _loop = function _loop(_name) {
      var rule = def.rules[_name];
      Assert(typeof rule === 'object', 'Invalid rule definition for', def.type, _name);
      var method = rule.method;
      if (method === undefined) {
        method = function method() {
          return this.$_addRule(_name);
        };
      }
      if (method) {
        Assert(!prototype[_name], 'Rule conflict in', def.type, _name);
        prototype[_name] = method;
      }
      Assert(!rules[_name], 'Rule conflict in', def.type, _name);
      rules[_name] = rule;
      if (rule.alias) {
        var aliases = [].concat(rule.alias);
        var _iterator = _createForOfIteratorHelper(aliases),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var alias = _step.value;
            prototype[alias] = rule.method;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (rule.args) {
        rule.argsByName = new Map();
        rule.args = rule.args.map(function (arg) {
          if (typeof arg === 'string') {
            arg = {
              name: arg
            };
          }
          Assert(!rule.argsByName.has(arg.name), 'Duplicated argument name', arg.name);
          if (Common.isSchema(arg.assert)) {
            arg.assert = arg.assert.strict().label(arg.name);
          }
          rule.argsByName.set(arg.name, arg);
          return arg;
        });
      }
    };
    for (var _name in def.rules) {
      _loop(_name);
    }
  }
  def.rules = rules;

  // Modifiers

  var modifiers = Object.assign({}, parent.modifiers);
  if (def.modifiers) {
    var _loop2 = function _loop2(_name2) {
      Assert(!prototype[_name2], 'Rule conflict in', def.type, _name2);
      var modifier = def.modifiers[_name2];
      Assert(typeof modifier === 'function', 'Invalid modifier definition for', def.type, _name2);
      var method = function method(arg) {
        return this.rule(_defineProperty({}, _name2, arg));
      };
      prototype[_name2] = method;
      modifiers[_name2] = modifier;
    };
    for (var _name2 in def.modifiers) {
      _loop2(_name2);
    }
  }
  def.modifiers = modifiers;

  // Overrides

  if (def.overrides) {
    prototype._super = base;
    schema.$_super = {};
    for (var override in def.overrides) {
      Assert(base[override], 'Cannot override missing', override);
      schema.$_super[override] = base[override].bind(schema);
    }
    Object.assign(prototype, def.overrides);
  }

  // Casts

  def.cast = Object.assign({}, parent.cast, def.cast);

  // Manifest

  var manifest = Object.assign({}, parent.manifest, def.manifest);
  manifest.build = internals.build(def.manifest && def.manifest.build, parent.manifest && parent.manifest.build);
  def.manifest = manifest;

  // Rebuild

  def.rebuild = internals.rebuild(def.rebuild, parent.rebuild);
  return schema;
};

// Helpers

internals.build = function (child, parent) {
  if (!child || !parent) {
    return child || parent;
  }
  return function (obj, desc) {
    return parent(child(obj, desc), desc);
  };
};
internals.coerce = function (child, parent) {
  if (!child || !parent) {
    return child || parent;
  }
  return {
    from: child.from && parent.from ? _toConsumableArray(new Set([].concat(_toConsumableArray(child.from), _toConsumableArray(parent.from)))) : null,
    method: function method(value, helpers) {
      var coerced;
      if (!parent.from || parent.from.includes(typeof value)) {
        coerced = parent.method(value, helpers);
        if (coerced) {
          if (coerced.errors || coerced.value === undefined) {
            return coerced;
          }
          value = coerced.value;
        }
      }
      if (!child.from || child.from.includes(typeof value)) {
        var own = child.method(value, helpers);
        if (own) {
          return own;
        }
      }
      return coerced;
    }
  };
};
internals.prepare = function (child, parent) {
  if (!child || !parent) {
    return child || parent;
  }
  return function (value, helpers) {
    var prepared = child(value, helpers);
    if (prepared) {
      if (prepared.errors || prepared.value === undefined) {
        return prepared;
      }
      value = prepared.value;
    }
    return parent(value, helpers) || prepared;
  };
};
internals.rebuild = function (child, parent) {
  if (!child || !parent) {
    return child || parent;
  }
  return function (schema) {
    parent(schema);
    child(schema);
  };
};
internals.validate = function (child, parent) {
  if (!child || !parent) {
    return child || parent;
  }
  return function (value, helpers) {
    var result = parent(value, helpers);
    if (result) {
      if (result.errors && (!Array.isArray(result.errors) || result.errors.length)) {
        return result;
      }
      value = result.value;
    }
    return child(value, helpers) || result;
  };
};